import ko from 'knockout';
import _ from 'underscore';
import { isFieldEditing } from '../../service/status';

/**
 * extend the observable for collapse
 * @param {Observable} local - observable define for property
 * @param {Object} attrs - property define
 * @param {FieldOption} fieldOption - field of property
 * @param {Object} viewModel - model value of entity
 * @returns {undefined} - the function extend passed local directly
 */
export function collapse(local, attrs, fieldOption, viewModel) {
  const isExpanded = _.isUndefined(fieldOption.isExpanded) ?
    isFieldEditing(fieldOption, viewModel) : fieldOption.isExpanded;
  _.extend(local, {
    isExpanded,
  });

  _.extend(local, {
    observable: ko.observable(local.isExpanded),
  });

  _.extend(local, {
    click: () => {
      const value = local.observable();

      local.observable(!value);
      return null;
    },
  });

  _.extend(local, fieldOption);
}
